module.exports = __webpack_public_path__ + "static/img/yuan_pan.a23fe31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/yuan_pan.png
// module id = PZvb
// module chunks = 2